import {
    VuexModule,
    Module,
    MutationAction,
    Mutation,
    Action,
    getModule,
} from 'vuex-module-decorators'
import store from '@/store'
import { ApiService } from '@/api/api.service'
import { UserModule } from './user'

export interface INotificationsState {
    notifications: any[]
    loading: boolean
    lastRefresh: Date
}

@Module({ dynamic: true, store, name: 'notifications', namespaced: true })
class Notifications extends VuexModule implements INotificationsState {
    public notifications = []
    public loading = false
    public lastRefresh = null

    @Mutation
    public updateNotifications(notifications) {
        this.notifications = notifications
    }

    @Mutation
    public updateLastRefresh(date) {
        this.lastRefresh = date
    }

    @Mutation
    public updateLoading(loading) {
        this.loading = loading
    }

    @Mutation
    public setDisplayedAt(payload) {
        this.notifications.forEach(x => {
            if (x.id === payload.id) {
                x.displayedAt = payload.date
            }
        })
    }

    @Action
    async ForceRefreshNotifications() {
        this.context.commit('updateLastRefresh', null)
        await this.context.dispatch('InitNotifications')
    }

    @Action({ commit: 'updateNotifications' })
    async InitNotifications() {
        const now = new Date()
        if (this.lastRefresh) {
            const diff = now.getTime() - this.lastRefresh.getTime()
            // < 3 secondes
            if (diff < 1000 * 3) {
                return this.notifications
            }
        }
        this.context.commit('updateLastRefresh', now)
        this.context.commit('updateLoading', true)

        try {
            if (UserModule.token == undefined) {
                await UserModule.Init()
            }
            const userID = UserModule.userInfos.id
            if (!userID) {
                this.context.commit('updateLoading', false)
                return this.notifications
            }

            const apiService = new ApiService()
            const resp = await apiService.getUserNotifications(userID)
            const userNotifications = resp.data

            console.log('notification init')
            this.context.commit('updateLoading', false)
            return userNotifications
        } catch (e) {
            this.context.commit('updateLoading', false)
            return this.notifications
        }
    }

    @Action
    async setNotificationAsDisplayed(notification) {
        if (UserModule.token == undefined) {
            await UserModule.Init()
        }

        const userID = UserModule.userInfos.id
        const apiService = new ApiService()
        const now = new Date()
        const req = {
            displayedAt: now,
            openedAt: notification.openedAt,
            closedAt: notification.closedAt,
            sentAt: notification.sentAt,
            reminderAt: notification.remindedAt,
        }

        await apiService.patchUserNotification(userID, notification.id, req)
        this.context.commit('setDisplayedAt', {
            id: notification.id,
            date: now,
        })
    }
}

export const NotificationsModule = getModule(Notifications)
